import store from '@/core/store';
import profile from './store/profile';

export const connect = (opts = {}) => {
  store.registerModule('profile$profile', profile);
};
